import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {INSTRUCTIONS_SEARCH_QUERY_KEY, INSTRUCTIONS_TENANT_ID} from '../../consts'

type Params = {
  plantId: string
  options?: UseMutationOptions<unknown, AxiosError, string>
}

export const useInstructionDelete = ({plantId, options}: Params) => {
  const queryClient = useQueryClient()
  return useMutation<unknown, AxiosError, string>({
    mutationFn: async (instructionId: string) => {
      const path = `/instructions/${INSTRUCTIONS_TENANT_ID}/plants/${plantId}/instructions/${instructionId}`
      const response = await ApiClient.axiosInstance.delete(path)
      return response.data
    },
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({queryKey: [INSTRUCTIONS_SEARCH_QUERY_KEY]})
      await options?.onSuccess?.(...args)
    }
  })
}
